import { Monitor } from 'lucide-react';

export const squarespaceIntegration = {
    id: 'squarespace',
    name: 'Squarespace',
    icon: Monitor,
    platformColor: '#000000',
    title: 'Squarespace Setup',
    why: 'Squarespace offers seamless integration through its built-in Code Injection feature, enabling you to add AI-powered customer support in minutes.',
    detailedGuide: '/docs/squarespace',
    steps: [
        {
            title: "Access ChytBot Dashboard",
            desc: "Log in to your ChytBot account. Navigate to \"Add to Website\" from the sidebar and copy your unique chatbot code snippet.",
            image: "/docs/screenshots/squarespace/integration.jpg",
            imgAlt: "ChytBot Add to Website"
        },
        {
            title: "Open Squarespace Dashboard",
            desc: "Log in to your Squarespace account and select the website you want to manage.",
            image: "/docs/screenshots/squarespace/suqarespace_dashboard.png",
            imgAlt: "Squarespace Dashboard"
        },
        {
            title: "Navigate to Website Settings",
            desc: "From the sidebar menu, click on \"Website\".",
            image: "/docs/screenshots/squarespace/squarespace_dashboard_website.png",
            imgAlt: "Website Menu"
        },
        {
            title: "Open Website Tools",
            desc: "Scroll to the bottom of the menu and click on \"Website Tools\".",
            image: "/docs/screenshots/squarespace/navigate_to_code_injection.png",
            imgAlt: "Website Tools"
        },
        {
            title: "Select Code Injection",
            desc: "Click on \"Code Injection\" from the tools menu.",
            image: "/docs/screenshots/squarespace/code_injection.png",
            imgAlt: "Code Injection Menu"
        },
        {
            title: "Paste Chatbot Code",
            desc: "In the \"Header\" section, paste your ChytBot embed code. Click \"Save\" at the top left corner.",
            image: "/docs/screenshots/squarespace/paste_chatbot_code.png",
            imgAlt: "Pasting Code"
        },
        {
            title: "Verify Integration",
            desc: "Open your website in a new browser tab. Your chatbot should now appear in the bottom corner, ready to assist visitors!",
            image: "/docs/screenshots/squarespace/chytbot.png",
            imgAlt: "Live ChytBot"
        }
    ]
};
